import BusinessApplication from './BusinessApplication';

export default BusinessApplication;
